import { convertFieldsToSearch } from 'services/helper';
import BaseApi from '../BaseApi';
import { UserApiConverter } from './UserApiConverter';
import parseNumberFromString from 'shared/helpers/parseNumberFromString';

class UserApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.baseUrl2 = `${baseUrl}/api/user`;
    this.converter = new UserApiConverter();
  }

  getUserInfo = ({ id }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/user/${id}/`,
      undefined,
      undefined,
      data => this.converter.convertUserInfo(data),
      data => this.validator.validateGetUserInfo(data, `${this.baseUrl}/user/${id}/`),
    );

  createUser = requestBody => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/user/`, requestBody);

  depositOrWithdrawal = ({ id, operation, amount, bonusAmount, bonusPercentAmount, isBonus }) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/user/${id}/payment/`, {
      operation,
      amount: parseNumberFromString(amount),
      is_bonus: isBonus || undefined,
      percent_amount: isBonus && +bonusPercentAmount ? +bonusPercentAmount : undefined,
      bonus_amount: isBonus && bonusAmount ? parseNumberFromString(bonusAmount) : undefined,
    });

  getUsersList = ({ userId, isBanned, isReferral, isDirectStructure, ...data }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/user/${convertFieldsToSearch({
        ...data,
        user_id: userId ?? null,
        is_banned: isBanned ?? null,
        is_referred: isReferral ?? null,
        is_direct_structure: isDirectStructure ?? null,
      })}`,
      null,
      null,
      this.converter.convertUsersList,
      { role: data.role },
    );

  changeBanState = (id, value) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/change_attribute`, {
      operation: 'change_ban',
      target_id: id,
      is_banned: value,
    });

  changeUserBalance = (id, amount, isOutcome) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/change_attribute`, {
      operation: 'change_balance',
      target_id: +id,
      amount: +amount,
      is_outcome: isOutcome,
    });

  resetPassword = (id, new_password) =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/change_attribute`,
      {
        operation: 'change_password',
        target_id: id,
        new_password: new_password,
      },
      null,
      this.converter.convertNewPassword,
    );

  changeUserInfo = ({ data, id }) => {
    return this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/user/${id}/`, data);
  };

  getBannedProviders = ({ id }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/user/${id}/blocklist/`,
      null,
      null,
      this.converter.convertBannedProviders,
    );

  setBannedProviders = ({ data }) =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/user/${data.id}/blocklist/`,
      {
        providers: data.providers,
        action: data.action,
        category: data.category,
        is_full_branch: data.isFullBranch,
        semi_auto_withdrawal_enabled: data.semiAutoWithdrawalEnabled,
        is_visible_feedback_link: data.isVisibleFeedbackLink,
      },
      null,
      this.converter.convertBannedProvidersSet,
    );

  getUserInfo = ({ id }) =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/user/${id}/`, null, null, this.converter.convertUserInfo);

  getProfileInfo = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/bank/`, null, null, this.converter.convertProfileInfo);

  getRefCode = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/refcode`, undefined, undefined, d => d?.ref_code);

  getCashbackInfo = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl2}/cashback/info`, undefined, undefined, () => {});
}

export default UserApi;
